export enum ProcedureBackend {
  Angular = 'angular',
  Sfdc = 'sfdc',
}

export const PROCEDURE_CONFIG_NAMES = {
  CREDIT_CARD: 'credit-card',
  FF_DRAWER: 'ff-drawer',
  CONTRACT_LOAN: 'contract-loan',
  SECURITIES_REISSUE: 'securities-reissue',
  FIXED_PREMIUM_CHANGE: 'fixed-premium-change',
  BANK_ACCOUNT_CHANGE: 'bank-account-change',
  BANK_ACCOUNT_CHANGE_PAPER: 'bank-account-change-paper',
  BANK_ACCOUNT_CHANGE_DIGITAL: 'bank-account-change-digital',
  SURRENDER: 'surrender',
  INSURANCE_PREMIUM_DEDUCTION_CERTIFICATE:
    'insurance-premium-deduction-certificate',
  ADDRESS_TEL_CHANGE: 'address-tel-change',
  FAMILY_NAME_CHANGE: 'family-name-change',
  OWNER_NAME_CHANGE: 'owner-name-change',
  SURRENDER_REQUEST_FORM_MAILING: 'surrender-request-form-mailing',
} as const;